import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface SsrDetailPreviewData {
  title: string;
  url: string;
}

@Component({
  selector: 'ig-ssr-detail-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ssr.detail.preview.component.html',
  styleUrl: './ssr.detail.preview.component.scss',
})
export class SsrDetailPreviewComponent implements OnInit, OnDestroy {
  src: SafeResourceUrl | null = null;
  loading = false;
  error = '';
  private timeout?: ReturnType<typeof setTimeout>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SsrDetailPreviewData,
    public dialog: MatDialogRef<SsrDetailPreviewComponent>,
    private sanitizer: DomSanitizer,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.clearTimeout();
    this.loading = true;
    this.error = '';
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    this.timeout = setTimeout(() => {
      this.frameFailed('Loading details timed out. Please try again.');
    }, 20000);
  }

  frameLoaded(frame: HTMLIFrameElement): void {
    if (!this.src) return;

    // Cross-origin iframe content is inaccessible; let the API display its response.
    try {
      if (frame.contentWindow?.location.href === 'about:blank') return;
      const document = frame.contentDocument;
      if (document && !document.querySelector('.ig-ssr-widget')) {
        this.frameFailed('Unable to load details. The item may be unavailable, or the detail preview API key may be missing or invalid.');
        return;
      }
    } catch (_error) {}

    this.clearTimeout();
    this.loading = false;
    this.changeDetector.markForCheck();
  }

  frameFailed(message = 'Unable to display details. Please check your network connection and iframe policy.'): void {
    this.clearTimeout();
    this.src = null;
    this.loading = false;
    this.error = message;
    this.changeDetector.markForCheck();
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  private clearTimeout(): void {
    clearTimeout(this.timeout);
    this.timeout = undefined;
  }
}
